// extracted by mini-css-extract-plugin
export default {"orderStatus":"G67da3f"};